import { render, staticRenderFns } from "./ToolsPage.vue?vue&type=template&id=1c332f8e&scoped=true&"
import script from "./ToolsPage.vue?vue&type=script&lang=js&"
export * from "./ToolsPage.vue?vue&type=script&lang=js&"
import style0 from "./ToolsPage.vue?vue&type=style&index=0&id=1c332f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c332f8e",
  null
  
)

export default component.exports